import React from "react";
import Loader from "components/Loader";
import Rto from "./rtoUpdate";


const TransactionStageSelector = ({ data }) => {
  const [showLoader, setShowLoader] = React.useState(false);

  function setLoader(value) {
    setShowLoader(value);
  }
  if (showLoader) return <Loader />;

  if (data.transactionStatus === null || data.transactionStatus === undefined)
    return <div>Error</div>;

  if (data.transactionStatus === "FINAL_INVOICE_COMPLETED") {
    return <Rto data={data} setLoader={setLoader} />;
  }

  if (data.transactionStatus === "RTO_COMPLETED") {
    return <div>RTO Process Completed</div>;
  }

  return <div>Error</div>;
};

export default TransactionStageSelector;
